export default __webpack_public_path__ + "static/media/Group 22.a6e62504.png";